/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 *
 * Implements Storage interface
 * https://developer.mozilla.org/en-US/docs/Web/API/Storage
 */
define([], function() {
    return {
        /**
         * @var {number}
         */
        length: 0,

        /**
         * @param {string} key
         * @param {string} value
         * @private
         */
        setItem: function(key, value) {
            var date = new Date(2030, 11, 31); // just future date

            document.cookie = key + '=' + value + '; path=/; expires=' + date.toUTCString();
            this.length++;
        },

        /**
         * @param {string} key
         * @returns {string|null}
         */
        getItem: function(key) {
            var name = key + '=';
            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }

            return null;
        },

        /**
         * @param {string} key
         * @returns {string|null}
         */
        removeItem: function(key) {
            var date = new Date(1970, 1, 1); // just date in the past
            document.cookie = key + '=; expires=' + date.toUTCString();
        }
    };
});
